import GRPCLuna from "./GRPCLuna";
import {E24UserAccountSignUpRequest, E24UserAccountSignUpResponse, EudUserAccountSignUp,EudUserAccountSignUpCode} from "@ev24/proto-eud-luna-web-api/elwa_v1_pb";
import type {Reject, Resolve} from "../utility/InterfacePromise";
import type {RpcError} from "grpc-web";
import useAlertStore from "../store/AlertStore";
import type {GRPCHandler} from "./GRPCLuna";

export default class LunaSignup extends GRPCLuna {
    public async signUp(username: string, fullName: string, email: string, password: string, signUpCode: string, recaptcha: string, handler: GRPCHandler | null = null): Promise<unknown> {
        const UUID = this.getUuid();
        const clientService = this.userAccountClient();
        const request: E24UserAccountSignUpRequest = new E24UserAccountSignUpRequest();

        request.setRequestId(UUID);
        request.setRecaptchaToken(recaptcha);

        const payload: EudUserAccountSignUp = new EudUserAccountSignUp();
        payload.setEmail(email);
        payload.setPassword(password);
        payload.setFullName(fullName);
        payload.setUsername(username);

        const codePayload: EudUserAccountSignUpCode = new EudUserAccountSignUpCode();
        codePayload.setCode(signUpCode);
        payload.setSignUpCode(codePayload);

        request.setPayload(payload);
        return new Promise((resolve: Resolve, reject): void => {
            clientService.signup(
                request,
                this._headers,
                (err: RpcError | null, response) => {
                    if(!handler) {
                        this.signUpHandler(response, err, resolve, reject);
                    } else {
                        handler(response, err, resolve, reject);
                    }

                }
            );
        });
    }

    protected signUpHandler(response: E24UserAccountSignUpResponse | null, err: RpcError | null, resolve: Resolve, reject: Reject) {
        const alertStore = useAlertStore();
        const responseData: E24UserAccountSignUpResponse.AsObject | null = this.responseData(
            <E24UserAccountSignUpResponse>response
        );
        if (!responseData) {
            alertStore.error("Oops something went wrong: Error SU1002");
            console.error({err}, {responseData});
            reject(err);
            return;
        }
        if (parseInt(responseData.code) === 200) {
            alertStore.success("Thank you for signing up with Evolve24!");
            resolve(responseData);
        } else if (parseInt(responseData.code) === 422) {
            resolve(responseData);
        } else {
            const message = responseData?.message || err?.message || "Server Error: SU1001";
            alertStore.error(message);
            console.error(err);
            reject(err);
        }
    }

}